<template>
  <div class="head">
    <img class="head-avatar" :src="hasLogin ? userInfo.pic || avatarHolder : avatarHolder" alt="avatar"/>

    <p class="head-name">{{ hasLogin ? userInfo.nickname : '' }}</p>

    <div class="head-stat">

      <dl class="head-stat-sum">
        <dt>{{ hasLogin ? Math.ceil(data.cumulativeLearn / 60) || 0 : 0 }}</dt>
        <dd>累计学习（分钟）</dd>
      </dl>

      <div class="head-stat-sep"/>

      <dl class="head-stat-week">
        <dt>{{ hasLogin ? Math.ceil(data.weekLearn / 60) || 0 : 0 }}</dt>
        <dd>本周学习（分钟）</dd>
      </dl>

    </div>

    <!--<img class="head-privilegeTag" src="../../assets/images/mine-learn-card.png" @click="$emit('to-privilege')"/>-->
  </div>
</template>

<script>
import avatarHolder from './.default/avatar.png'
import login from '@/utils/login'

export default {
  props: {
    styleExt: {
      type: Object,
      default: function () {
        return {}
      }
    },
    data: Object,
    userInfo: Object
  },

  data () {
    return {
      avatarHolder
    }
  },
  created() {
  },
  computed: {
    hasLogin () {
      return login.getWpsSid()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/main.scss";

$global-width: 750;

.head {
  position: relative;
  height: rem(210);
  width: rem(690);
  margin: rem(70) auto rem(30) auto;
  padding-top: rem(82);
  border-radius: rem(8);
  background-color: #fff;
  box-shadow: 0 rem(12) rem(17) rgba(0,0,0,.2);

  &-avatar {
    position: absolute;
    top: rem(-60);
    left: 0;
    right: 0;
    margin: 0 auto;
    height: rem(120);
    width: rem(120);
    border-radius: 50%;
  }

  &-name {
    text-align: center;
    color: #999999;
    font-size: rem(26);
    margin-bottom: rem(43);
  }

  &-stat {
    height: rem(134);
    width: rem(515);
    margin: 0 auto;

    dl {
      display: inline-block;
      width: rem(200);
      height: 100%;

      dt {
        width: rem(200);
        height: rem(67);
        text-align: center;
        color: #555555;
        font-size: rem(48);
        line-height: rem(67);
      }

      dd {
        width: rem(200);
        text-align: center;
        color: #999999;
        font-size: rem(22);
      }
    }

    &-sum {
      float: left;
    }

    &-week {
      float: right;
    }

    &-sep {
      position: absolute;
      top: rem(164);
      left: 0;
      right: 0;
      margin: 0 auto;
      height: rem(80);
      width: 1px;
      background-color: #D8D8D8;
    }
  }

  &-privilegeTag {
    position: absolute;
    top: rem(26);
    right: 0;
    height: rem(48);
    width: rem(150);
  }
}
</style>
